import { render, staticRenderFns } from "./Clientput.vue?vue&type=template&id=4ff8ab0a"
import script from "./Clientput.vue?vue&type=script&lang=js"
export * from "./Clientput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports